var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMedicalBw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 36,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.6668 51.4167H19.3335C18.6502 51.4167 18.0835 51.9834 18.0835 52.6667C18.0835 53.35 18.6502 53.9167 19.3335 53.9167H52.6668C53.3502 53.9167 53.9168 53.35 53.9168 52.6667C53.9168 51.9834 53.3502 51.4167 52.6668 51.4167Z",
    fill: "#777777"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3333 19.3333H27.6667C22.6667 19.3333 21 22.3166 21 26V52.6666H31V42.5666C31 41.7 31.7 41 32.5667 41H39.45C40.3 41 41.0167 41.7 41.0167 42.5666V52.6666H51.0167V26C51 22.3166 49.3333 19.3333 44.3333 19.3333ZM40.1667 31.4166H37.25V34.3333C37.25 35.0166 36.6833 35.5833 36 35.5833C35.3167 35.5833 34.75 35.0166 34.75 34.3333V31.4166H31.8333C31.15 31.4166 30.5833 30.85 30.5833 30.1666C30.5833 29.4833 31.15 28.9166 31.8333 28.9166H34.75V26C34.75 25.3166 35.3167 24.75 36 24.75C36.6833 24.75 37.25 25.3166 37.25 26V28.9166H40.1667C40.85 28.9166 41.4167 29.4833 41.4167 30.1666C41.4167 30.85 40.85 31.4166 40.1667 31.4166Z",
    fill: "#777777"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedicalBw);
export default __webpack_public_path__ + "static/media/medical-bw.bc32e2d5daa3b73fc4677b8bf00ea329.svg";
export { ForwardRef as ReactComponent };